<template>
    <div>
        <b-loading :is-full-page="true" :active.sync="isFetchingJobTitles" :can-cancel="false"></b-loading>
        <h3 class="title is-3">Manage Job title</h3>
        <hr />
        <div class="columns">
            <div class="column is-2">
                <div class="field">
                    <label class="label is-small">Department</label>
                    <div class="control">
                        <b-autocomplete v-model="departmentName" size="is-small" :data="departments" placeholder="Search departments" @select="option => selectedDepartment = option" @input="searchDepartments" :loading="isFetchingDepartments" v-validate="'required'" name="Department name">
                            <template slot="empty">
                                <span v-if="isFetchingDepartments">
                                    Please wait...
                                </span>
                                <span v-if="departments.length === 0">
                                    No results found
                                </span>
                            </template>
                        </b-autocomplete>
                        <span style="font-size:12px" class="has-text-danger">{{ errors.first('Department name') }}</span>
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <label class="label is-small">Job Title</label>
                    <div class="control">
                        <input type="text" v-model="jobTitle.title" class="input is-small" v-validate="'required'" name="Job title" />
                        <span style="font-size:12px" class="has-text-danger">{{ errors.first('Job title') }}</span>
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <label class="label is-small">Desc</label>
                    <div class="control">
                        <input type="text" v-model="jobTitle.desc" class="input is-small" />
                    </div>
                </div>
            </div>
        </div>
        <button :class="buttonSave" @click="saveJobTitle">{{createOrEdit}}</button>
        &nbsp;
        <button v-show="createOrEdit == 'Update'" class="button is-small" @click="cancelEdit">Cancel</button>
        <div style="clear:both"></div>
        <br />
        <b-table :data="jobTitles" :bordered="true" :striped="true" :narrowed="true" :hoverable="true" :mobileCards="true">
            <template slot-scope="item">
                <b-table-column field="jobTitleId" class="table-column-content-is-small" label="ID">
                    {{item.row.jobTitleId}}
                </b-table-column>
                <b-table-column field="department" class="table-column-content-is-small" label="Department">
                    {{item.row.department}}
                </b-table-column>
                <b-table-column field="title" class="table-column-content-is-small" label="Name">
                    {{item.row.title}}
                </b-table-column>
                <b-table-column field="desc" class="table-column-content-is-small" label="Desc.">
                    {{item.row.desc}}
                </b-table-column>
                <b-table-column>
                    <button class="button is-small is-warning" @click="editJobTitle(item.row.jobTitleId)">Edit</button> &nbsp;
                    <button class="button is-small is-danger" @click="deleteJobTitle(item.row.jobTitleId)">Delete</button>
                </b-table-column>
            </template>
        </b-table>
        <div class="modal is-active" v-show="showDeleteModal">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Delete Job title</p>
                    <button class="delete" aria-label="close"></button>
                </header>
                <section class="modal-card-body">
                    <!-- Content ... -->
                    Are you sure do you want to delete this permanently?
                </section>
                <footer class="modal-card-foot" style="justify-content:flex-end">
                    <button :class="buttonDelete" @click="deletePermanently">Yes</button>
                    <button class="button is-small" @click="cancel">No</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import debounce from 'lodash/debounce'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data() {
    return {
      createOrEdit: 'Create',
      showDeleteModal: false,
      jobTitle: {},
      jobTitles: [],
      // select department
      departmentName: '',
      isFetchingJobTitles: false,
      departments: [],
      selectedDepartment: 0,
      isFetchingDepartments: false,
      buttonSave: appButton.isLoadingSuccess(false),
      buttonDelete: appButton.isLoadingDanger(false)
    }
  },
  created() {
    this.getJobTitles()
  },
  methods: {
    saveJobTitle() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.buttonSave = appButton.isLoadingSuccess(true)
          const jobTitle = this.jobTitle.jobTitleId
          if (jobTitle) {
            // Edit
            axios
              .put(`api/jobTitles/${jobTitle}`, this.jobTitle)
              .then(response => {
                appToast.success(response.data)
              })
              .catch(error => {
                console.log(error)
              })
              .then(() => {
                this.default()
              })
          } else {
            axios
              .post(`api/jobTitles`, this.jobTitle)
              .then(response => {
                appToast.success(response.data)
              })
              .catch(error => {
                console.log(error)
              })
              .then(response => {
                this.default()
              })
          }
        }
      })
    },
    searchDepartments: debounce(function() {
      this.isFetchingDepartments = true
      axios
        .get(`api/departments/search-by-name/${this.departmentName}`)
        .then(response => {
          this.departments = response.data
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.isFetchingDepartments = false
        })
    }, 500),
    getJobTitles() {
      this.isFetchingJobTitles = true
      axios
        .get('api/jobTitles')
        .then(response => {
          this.jobTitles = response.data
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.isFetchingJobTitles = false
        })
    },
    editJobTitle(id) {
      axios
        .get(`api/jobTitles/${id}`)
        .then(response => {
          this.jobTitle = response.data
          this.departmentName = response.data.department
          this.createOrEdit = 'Update'
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteJobTitle(id) {
      this.showDeleteModal = true
      this.jobTitle.jobTitleId = id
    },
    deletePermanently() {
      if (this.showDeleteModal) {
        this.buttonDelete = appButton.isLoadingDanger(true)
        const jobTitleId = this.jobTitle.jobTitleId
        if (jobTitleId) {
          axios
            .delete(`api/jobTitles/${jobTitleId}`)
            .then(response => {
              appToast.success(response.data)
            })
            .catch(error => {
              console.log(error)
            })
            .then(() => {
              this.default()
            })
        }
      }
    },
    cancel() {
      this.showDeleteModal = false
    },
    default() {
      this.createOrEdit = 'Create'
      this.jobTitle = {}
      this.showDeleteModal = false
      this.getJobTitles()

      // select department default
      this.departmentName = ''
      this.departments = []
      this.selectedDepartment = 0
      this.isFetchingDepartments = false

      this.$nextTick(() => {
        this.$validator.reset()
      })

      this.buttonSave = appButton.isLoadingSuccess(false)
      this.buttonDelete = appButton.isLoadingDanger(false)
    },
    cancelEdit() {
      this.default()
    }
  },
  watch: {
    selectedDepartment() {
      if (this.selectedDepartment) {
        this.jobTitle.departmentId = this.selectedDepartment.id
      }
    }
  }
}
</script>

